<template>
  <div class="workbench-app">
    <div class="workbench-app__main-container">
      <div class="workbench-app__attribute-panel">
        <attribute-panel
          class="workbench-app__main-container__side-panel"
          :setOfAttributes="attributes"
          :onSelect="selectAttribute"
          :workbenchHeaderData="copiedTarget"
          :selectedValues="selectedXandrAttributes"
          :canEditTargetHeaderData="canEditTargetHeaderData"
          :datasetFilter="datasetFilter"
          :viewOnly="viewOnly">
        </attribute-panel>
      </div>
      <div class="workbench-app__main-container__slotted">
        <!-- need to figure out the flex stuff so that we can have a slot here-->
        <slot name="main-container" :slottedValue="workbenchSlottedValue"></slot>
      </div>

    </div>
    <div class="workbench-app__bottom-pane">
      <slot name="bottom-pane" :copiedTarget="copiedTarget"></slot>
    </div>
  </div>
</template>

<script>
/**
 * 1. insert the common component
 *    a. the common component will contain the following
 *        i. the attribute panel
 *        ii. the attribute boolean logic area
 *        iii. the slotted area for the graphs and shit
 *        iv. it will contain some information for the target, like the name and the type
 *        v. contains the link back to the Attribute Hub or whatever
 *        vi. the buttons that will be used,  we can make this a named slotted component
 *
 *      MMMMORE things to follow in the following week
 * I need to get the data ready for the 2 workbenches
 * 1. need to get the LAS attributes into the attribute panel
 * 2. need to get the Xandr Attributes into the atribute panel
 *
 * TODO need to have the following occur
 *  1. we need to call the following when the definition changes
 *    a. the universe
 *    b. the monnthly count
 *    c. the demographics
 *    d. the secondary networks table information
 *
 *
 * 1. We get to the page, we will need to stop everything
 *    a. get the segment, segement will return with the current query from Xandr
 *    b. place the query as the target definition (will need to convert the Xandr Query API into the targetDefinition)
 *
 *  SOLUTIONS
 *    a. the query will come from the xandr_segment_data table in the Audience Matters realm....
 *        this assumes that the query was not changed on the Audience matters team, if the query can be changed in Xandr as well as AM, then we will have to create the convertion function to convert them
 * 2. when we change the target definition
 *    a. we will send out a query to get the new counts
 * 3. when the user wants to save the target
 *    a. we will wait for the queryId then we will proceed with saving the target on Xandr's end.
 */

/**
 * 1. the original target is always going to be changing
 * 2. so when we need to copy over the workbenchtarget, only when the target can really be saved
 * 3. so we really want to change it when we are in new mode, I think the store should hold the copied target and then
 * 4. we can move it over
 *
 * 1. the original target changes the query
 * 2. have to update the copied target
 * 3. need to update the name and advertiser of the target as well
 *
 * 1. if we did not have a copied target, then we would just copy the target on fetch
 * 2. then we would make calls to update the target whenever it needs to update
 * 3. on fetches we would set the original
 * 4. on update insights we would update the query
 */
import AttributePanel from './attributePanel'
import { ADD_ATTRIBUTE } from '@/appComponents/workbench/targetDefinition/store/actions'
import {
  UPDATE_TARGET_DEFINITION_RELATED_INFORMATION,
  SET_TARGET,
  SET_ENABLE_SAVE_BUTTON,
  SET_ENABLE_DOWN_STREAM,
  RESET_STORE,
  INITIALIZE_TARGET_DEF,
  RESET_FAMILY_DATASETS
} from '@/appLogic/workbench/common/store/actions'
import { cloneDeep } from 'lodash'
import { ACTIVATION_STATUS } from '@/appLogic/targets/Constants'

export default {
  components: {
    AttributePanel
  },
  props: {
    copiedTarget: {
      type: Object
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      currentBottomPaneSize: 'medium',
      firstAttempt: true
    }
  },
  mounted () {
    // this page should never have overflow
    document.querySelector('html').style.overflow = 'hidden'
    // this.$store.dispatch('workbench/' + RESET_FAMILY_DATASETS)
  },
  destroyed () {
    document.querySelector('html').style.overflow = ''  // reset the overflow back
    // this.$store.dispatch('workbench/' + RESET_STORE)
    this.firstAttempt = true
  },
  computed: {
    datasetFilter () {
      return this.$store.getters['workbench/datasetFilter']
    },
    selectedXandrAttributes () {
      return this.$store.getters['workbench/newDictOfTargetAttributes']
    },
    attributes () {
      let attrs = this.$store.getters['workbench/workbenchAttributes']
      if (attrs) {
        return attrs
      } else {
        return null
      }
    },
    targetDefinition () {
      return this.$store.getters['workbench/newTargetDefinition']
    },
    sizeClass () {
      return `is-${this.currentBottomPaneSize}`
    },
    workbenchSlottedValue () {
      // you can find the workbench store name in the index section of the workbench appLogic store
      return this.$store.state.workbench.slottedValue
    },
    canEditTargetHeaderData () {
      // TODO_AFTER this has to be an interface variable and not a exposed computed value
      return true
      // return this.viewOnly && this.$store.state.workbench.xandr_workbench.enableUpdateTargetHeaderData
    },
    workbenchTarget () {
      return this.$store.getters['workbench/newWorkbenchTarget']
    }
  },
  methods: {
    selectAttribute ({item, event}) {
      if ([ACTIVATION_STATUS.WORKING, ACTIVATION_STATUS.DRAFT, ACTIVATION_STATUS.FAILED].indexOf(
        this.workbenchTarget.activation_status) > -1) {
        this.$store.dispatch('workbench/' + ADD_ATTRIBUTE, cloneDeep(item))
        this.$store.dispatch('workbench/' + RESET_FAMILY_DATASETS)
      }
    },
    changeBottomPaneSize (size) {
      this.currentBottomPaneSize = size
    },
    fetchTargetDefinitionInfo (td) {
      if (!this.firstAttempt && this.copiedTarget && (this.copiedTarget.activation_status === ACTIVATION_STATUS.WORKING || this.copiedTarget.activation_status === ACTIVATION_STATUS.DRAFT)) {
        if (td.length > 0) {
          this.$store.dispatch('workbench/' + SET_ENABLE_SAVE_BUTTON, true)
          this.$store.dispatch('workbench/' + SET_ENABLE_DOWN_STREAM, true)
        } else {
          this.$store.dispatch('workbench/' + SET_ENABLE_SAVE_BUTTON, false)
          this.$store.dispatch('workbench/' + SET_ENABLE_DOWN_STREAM, false)
        }
      }
      if (!this.firstAttempt) {
        if (td.length > 0) {
          this.$store.dispatch('workbench/' + UPDATE_TARGET_DEFINITION_RELATED_INFORMATION)
        }
      } else {
        this.$store.dispatch('workbench/' + INITIALIZE_TARGET_DEF, this.$store.getters['workbench/getDefinition'])
      }
      this.firstAttempt = false
    }
  },
  watch: {
    targetDefinition () {
      console.log('target definition changed')
      if (this.workbenchTarget) {
        this.fetchTargetDefinitionInfo(this.targetDefinition)
      }
    },
    workbenchTarget () {
      if (!this.workbenchTarget) {
        this.firstAttempt = true
      }
    }
  }
}
</script>

<style lang="scss">
  $lightGrayBackground: #E7EBED;

.workbench-app {
  height: 100%;
  display: flex;
  flex-direction: column;

  html {
    overflow: hidden;
  }
  &__attribute-panel {
    width: 25vw;
    min-width: 250px;
  }

  &__main-container {
    flex: 1 1 auto;
    display: flex;
    min-height: 0px;

    &__side-panel {
      margin-right: auto;
      transition: width .25s $global-easing;
      height: 100%;
      flex: 1 1;

      &.is-expanded-view {
        width: rem(600);
      }
      &.is-collapsed {
        width: rem(30);
      }
    }

    &__slotted {
      flex: 1 1;
      // flex: 1 1 auto;
      display: inline;
      align-items: center;
      background-color: $lightGrayBackground;
      padding: 0.5em;
    }
  }

  &__bottom-pane {
    display: flex;
    flex-direction: column;
    color: white;
    background: color(blue-black, darker);
    transition: height .25s $global-easing;

    &.is-small {
      flex: 0 1 0px;
      overflow: hidden;
    }

    &.is-medium {
      flex: 0 1 rem(190);
    }

    &.is-large {
      flex: 0 1 rem(450);
    }
  }
}
</style>



// WEBPACK FOOTER //
// WorkbenchCanvas.vue?3517090a